import { METER_TYPE } from 'config/const';

const { v4: uuidv4 } = require('uuid');
const moment = require('moment');

export const generateFakeMeterReadings = (employee, employeeName, initialReadValue, list) => {
    const meters = [
        { id: "67a2471ab6e76eca0240a508", name: "קומה 1", type: METER_TYPE.ELECTRICITY },
        { id: "67a32b230e2e3bece3ad0413", name: "קומה 1", type: METER_TYPE.WATER },

        { id: "67a24702b6e76eca0240a5044", name: "קומה 2", type: METER_TYPE.ELECTRICITY },
        { id: "67a2470fb6e76eca0240a5062", name: "קומה 2", type: METER_TYPE.WATER },

        { id: "67a32b050e2e3bece3ad03d37", name: "בריכה", type: METER_TYPE.ELECTRICITY },
        { id: "67a39a8effd9489ef68d8fbc", name: "בריכה", type: METER_TYPE.CHLORINE },
        { id: "67a32b230e2e3bece3ad04134", name: "בריכה", type: METER_TYPE.WATER },

        { id: "67a32b050e2e3bece3ad03d375", name: "בריכת פעוטת", type: METER_TYPE.ELECTRICITY },
        { id: "67a39a8effd9489ef68d8fbc12", name: "בריכת פעוטת", type: METER_TYPE.CHLORINE },
        { id: "67a32b230e2e3bece3ad041346", name: "בריכת פעוטת", type: METER_TYPE.WATER },

        { id: "67a32b050e2e3bece3ad03d37543", name: "בריכת גלים", type: METER_TYPE.ELECTRICITY },
        { id: "67a39a8effd9489ef68d8fbc1232", name: "בריכת גלים", type: METER_TYPE.CHLORINE },
        { id: "67a32b230e2e3bece3ad04134643", name: "בריכת גלים", type: METER_TYPE.WATER },

        { id: "67a32b050e2e3bece3ad0654", name: "מטבח בשרי", type: METER_TYPE.ELECTRICITY },
        { id: "67a2470fb6e76eca0240a506", name: "מטבח בשרי", type: METER_TYPE.WATER },
        { id: "67a24743b6e76eca0240a50e", name: "מטבח בשרי", type: METER_TYPE.GAS },

        { id: "67a2471ab6e76eca0240a5085", name: "מטבח חלבי", type: METER_TYPE.ELECTRICITY },
        { id: "67a2470fb6e76eca0240a55454", name: "מטבח חלבי", type: METER_TYPE.WATER },
        { id: "67a24743b6e76eca0240a50e6", name: "מטבח חלבי", type: METER_TYPE.GAS },

        { id: "67a24702b6e76eca0240a504", name: "חדר אוכל", type: METER_TYPE.ELECTRICITY },
        { id: "67a2470fb6e76eca0240a50621", name: "חדר אוכל", type: METER_TYPE.WATER },
    ];

    const readings = [];
    const startDate = moment().subtract(2, 'years').startOf('day');
    const today = moment().startOf('day');

    const daysDifference = today.diff(startDate, 'days');

    const meterReadValues = {};
    meters.forEach(meter => {
        meterReadValues[meter.id] = initialReadValue; // התחל מכל ערך התחלתי
    });

    for (let i = 0; i < daysDifference * 2; i++) {
        const date = moment(startDate).add(i, 'days').set({
            hour: 8,
            minute: Math.floor(Math.random() * 11) - 5, // סטייה של עד 5 דקות
            second: 0,
            millisecond: 0
        });

        meters.forEach((meter, idx) => {
            const dailyIncrease = Math.floor(Math.random() * (80 - 50 + 1)) + 50; // ערכים בין 50 ל-80
            meterReadValues[meter.id] += dailyIncrease;

            readings.push({
                created: idx !== 0 && idx !== 5 ? date.toISOString() : null,
                employee,
                employeeName,
                id: uuidv4().replace(/-/g, '').substring(0, 24),
                meter: { id: meter.id, name: meter.name, type: meter.type, firstReadValue: 0 },
                readValue: meterReadValues[meter.id],
            });
        });
    }
    return readings;
}
